import { FavouriteCondition } from 'app/types-shared';
import { searchInAllFieldsDomain } from 'app/area/favourite/constants';

export function returnSearchQuery(conditions: FavouriteCondition[] = []) {
  const searchQueryDomainCondition = conditions.find(item => item?.domain?.v === searchInAllFieldsDomain);
  return searchQueryDomainCondition?.values[0].string;
}

export function mapQueryParams(queryParams: Record<string, string[]>): string {
  return queryParams && Object.keys(queryParams).length
    ? '?' + Object.entries(queryParams)
      .flatMap(([key, value]) =>
        Array.isArray(value)
          ? value.map(v => `${key}=${v}`)
          : `${key}=${value}`
      )
      .join('&')
    : undefined;
}
